export enum AssetOptionEnum {
  EDIT_ASSET = 'EDIT_ASSET',
  COPY_TO = 'COPY_TO',
  DUPLICATE = 'DUPLICATE',
  DELETE = 'DELETE',
}
